module.exports = __webpack_public_path__ + "img/device-data.b852d8fe.png";